import script from "./tab-storage.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-storage.vue?vue&type=script&setup=true&lang=js"

import "./tab-storage.vue?vue&type=style&index=0&id=0af68200&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0af68200"]])

export default __exports__